import { normalizeGovernanceAppKey } from "./effective-visible-apps.js";

/** Apps, für die Spielerprofil-Daten (Name, LK, Altersklasse, …) im Club-Kontext benötigt werden. */
export const APPS_REQUIRING_PLAYER_PROFILE = Object.freeze([
  "matchmixer",
  "clubmeisterschaft",
  "medenspiele",
  "tennis-live",
]);

const __PROFILE_APP_SET = new Set(
  APPS_REQUIRING_PLAYER_PROFILE.map((k) => String(k).trim().toLowerCase()).filter(Boolean)
);

function __normalizeAppKeyList(appKeys) {
  if (appKeys instanceof Set) return Array.from(appKeys);
  return Array.isArray(appKeys) ? appKeys : [];
}

/**
 * @param {unknown} appKeys
 * @returns {string[]} Kanonische App-Keys aus der Auswahl, die Spielerprofil-Freigabe nahelegen.
 */
export function appsRequiringPlayerProfile(appKeys) {
  const seen = new Set();
  const out = [];
  for (const raw of __normalizeAppKeyList(appKeys)) {
    const k = normalizeGovernanceAppKey(String(raw || ""));
    if (!k || seen.has(k)) continue;
    if (!__PROFILE_APP_SET.has(k.toLowerCase())) continue;
    seen.add(k);
    out.push(k);
  }
  return out;
}

/**
 * @param {unknown} appKeys
 * @returns {boolean}
 */
export function shouldOfferPlayerProfileShare(appKeys) {
  return appsRequiringPlayerProfile(appKeys).length > 0;
}

/**
 * @param {{ shareConsent?: boolean, selectedAppKeys?: unknown }} opts
 * @returns {{ share_player_profile: boolean, share_player_profile_for_apps: string[] }}
 */
export function buildPlayerProfileShareCapabilities({ shareConsent = false, selectedAppKeys = [] } = {}) {
  const forApps = shareConsent ? appsRequiringPlayerProfile(selectedAppKeys) : [];
  return {
    share_player_profile: Boolean(shareConsent && forApps.length),
    share_player_profile_for_apps: forApps,
  };
}
